
export function isInViewport(element: HTMLElement): boolean {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Partition function. Divides array into two based on a filter function.
 *
 * @param {array} array - Array to divide
 * @param {function} filter - Filtering function
 *
 * @returns {array<array>} - First is array of items that passed the filter, second is array of items that didn't pass
 */
export function partition<T>(
  array: T[],
  filter: (element: T, index: number, array: T[]) => boolean
): [T[], T[]] {
  const pass: T[] = [];
  const fail: T[] = [];
  array.forEach((e, idx, arr) => (filter(e, idx, arr) ? pass : fail).push(e));
  return [pass, fail];
}
